<template>
    <div :class="['sidebar--links', mobile ? 'mobile' : '']">
        <div class="sidebar--section">
            <h5 class="sidebar--header">Kaikille</h5>
            <router-link to="/yleista">Yleistä</router-link>
            <router-link to="/rangaistustaulukko">Rangaistustaulukko</router-link>
        </div>
        <div class="sidebar--section">
            <h5 class="sidebar--header" v-if="ranks.length > 0">Komennot &amp; Vastuualueet</h5>
            <router-link to="/rank/moderator" v-if="ranks.includes('moderaattori')">Moderaattori</router-link>
            <router-link to="/rank/rakentaja" v-if="ranks.includes('rakentaja')">Rakentaja</router-link>
            <router-link to="/rank/operator" v-if="ranks.includes('operaattori')">Operaattori</router-link>
            <router-link to="/rank/admin" v-if="ranks.includes('admin')">Admin</router-link>
        </div>
        <div class="sidebar--section">
            <h5 class="sidebar--header">Oppaat</h5>
            <router-link to="/oppaat/rangaistukset">Rangaistukset</router-link>
            <!-- <router-link to="/oppaat/alueet">Alueet</router-link> -->
        </div>
        <div class="sidebar--section">
            <h5 class="sidebar--header">Pluginit</h5>
            <router-link to="/pluginit/coreprotect">Core Protect</router-link>
            <router-link to="/pluginit/worldguard">Worldguard</router-link>
        </div>
        <div class="sidebar--section">
            <h5 class="sidebar--header">Muut Resurssit</h5>
            <router-link to="/muut/discordbot">Karanteeni Discord Bot</router-link>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'SidebarLinks',
    computed: {
        ...mapGetters('auth', ['ranks'])
    },
    props: ['mobile']
}
</script>

<style scoped>
h5 {
    text-transform: uppercase;
    font-size: 1em;
    font-weight: 700;
    color: var(--font-2);
    margin: 0;
}

a {
    display: block;
    padding: 6px 32px 6px 4px;
    color: var(--font-2);
    text-decoration: none;
    border-left: 2.5px solid rgba(33, 150, 243, 0);
    text-transform: none;
    font-size: 0.875em;
    font-weight: 400;
}

a:hover {
    background-color: rgba(0, 0, 0, 0.04);
    color: var(--accent-2);
}

.sidebar--links {
    display: flex;
    flex-direction: column;
    padding-bottom: 5em;
    -webkit-overflow-scrolling: touch;
}

.sidebar--section.mobile {
    display: flex;
    flex-direction: column;
    font-size: 1.1rem;
    padding-left: 0 !important;
}

a,
h5 {
    margin-bottom: 0.3em;
}

.mobile a,
.mobile h5 {
    white-space: nowrap;
}

.sidebar--section {
    margin: 0 0 16px 0;
    padding: 0;
}

.sidebar--section > a,
.sidebar--section > h5 {
    padding-left: 16px;
}

.router-link-active {
    border-left: 2.5px solid var(--accent-2);
}
</style>
